// extracted by mini-css-extract-plugin
export default {"titleHeader":"ModalItem_titleHeader__MDUXo","title":"ModalItem_title__pAUXM","content":"ModalItem_content__vtY2U","paragraph":"ModalItem_paragraph__bV0Yk"};